import { render } from "./SocialAccountAvatar.vue?vue&type=template&id=54bda964&scoped=true&ts=true"
import script from "./SocialAccountAvatar.vue?vue&type=script&lang=ts"
export * from "./SocialAccountAvatar.vue?vue&type=script&lang=ts"

import "./SocialAccountAvatar.vue?vue&type=style&index=0&id=54bda964&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bda964"]])

export default __exports__